import { ADD_GLOSSARY, DELETE_GLOSSARY, GLOSSARY_LIST, TM_DELETE, TM_ENABLE_DISABLE, TM_EXPORT, TM_LIST, UPLOAD_GLOSSARY_FILE } from "./types";


export const glossaryListAction = (data, onSuccess, onError) => {
    return {
        type: GLOSSARY_LIST,
        data,
        onSuccess,
        onError,
    };
};

export const addGlossaryAction = (data, onSuccess, onError) => {
    return {
        type: ADD_GLOSSARY,
        data,
        onSuccess,
        onError,
    };
};

export const deleteGlossaryAction = (data, onSuccess, onError) => {
    return {
        type: DELETE_GLOSSARY,
        data,
        onSuccess,
        onError,
    };
};

export const uploadGlossaryFile = (file, onSuccess, onError) => {
    return {
        type: UPLOAD_GLOSSARY_FILE,
        file,
        onSuccess,
        onError,
    };
};

export const translationMemoryListAction = (data, onSuccess, onError) => {
    return {
        type: TM_LIST,
        data,
        onSuccess,
        onError,
    };
};

export const translationMemoryDeleteAction = (data, onSuccess, onError) => {
    return {
        type: TM_DELETE,
        data,
        onSuccess,
        onError,
    };
};

export const translationMemoryEnableDisableAction = (data, onSuccess, onError) => {
    return {
        type: TM_ENABLE_DISABLE,
        data,
        onSuccess,
        onError,
    };
};

export const translationMemoryExportAction = (data, onSuccess, onError) => {
    return {
        type: TM_EXPORT,
        data,
        onSuccess,
        onError,
    };
};